module.exports = __webpack_public_path__ + "077d2d73e1556b2073fe54d989d7fb.svg";